var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#081754;stroke-miterlimit:10;}\r\n\t.st1{fill:#081754;}\r\n\t.st2{fill:none;stroke:#081754;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.8,18.4H3.4v-7.2c0-0.9,0.6-1.5,1.5-1.5h14.5c0.8,0,1.5,0.6,1.5,1.5L20.8,18.4L20.8,18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.6,9.7l-0.3-1.3V8.3l-0.2-0.9V7.3l-0.6-2.1c-0.3-1.2-1.3-1.9-2.4-1.9H7.9c-1.2,0-2.1,0.8-2.4,1.9L5,7.3 l-0.2,1L4.4,9.8l0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.4,18.4v1.6c0,0.3,0.3,0.6,0.6,0.6h0.5c0.3,0,0.6-0.3,0.6-0.6v-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.8,18.4v1.6c0,0.3-0.3,0.6-0.6,0.6h-0.5c-0.3,0-0.6-0.3-0.6-0.6v-1.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.2,8.3L19.2,8.3c0.4,0,0.7,0,1.1,0c0.2,0,0.5,0.1,0.6-0.1C21,7.9,21,7.8,21,7.6c0-0.2-0.2-0.3-0.4-0.3 c-0.2,0-0.3,0-0.5,0c-0.3,0-0.6,0-0.9,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.8,8.3c-0.3,0-0.7,0-1.1,0c-0.2,0-0.5,0.1-0.6-0.1C3,7.9,3,7.8,3,7.6c0-0.2,0.2-0.3,0.4-0.3 c0.2,0,0.3,0,0.5,0c0.3,0,0.7,0,1.1,0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 6.7,
    cy: 13.4,
    rx: 1.1,
    ry: 1.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 17.2,
    cy: 13.4,
    rx: 1.1,
    ry: 1.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 9.9,
    y1: 15.2,
    x2: 14.2,
    y2: 15.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 4.3,
    cy: 19.5,
    rx: 0.6,
    ry: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 20.1,
    cy: 19.5,
    rx: 0.6,
    ry: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.80d0c22267415e9c8699bcc5df61e1e4.svg";
export { ForwardRef as ReactComponent };